/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { VerifyAccountLink } from '../../../redux/features/auth/authActions';
import { INVALID_VERIFICATION_LINK, VERIFICATION_SUCCESS } from '../../../utlis/messages';


export function AccountVerify() {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const [verificationMessage, setVerificationMessage] = useState<string>('');
    const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email') || '';
    const otp = searchParams.get('otp') || null;


    useEffect(() => {
        if (email && otp) {
            dispatch(VerifyAccountLink({ email, otp }))
                .then((response: any) => {                    
                    if (response?.payload?.responseCode === 200) {
                        setVerificationMessage(VERIFICATION_SUCCESS);
                        setIsSuccess(true);
                    } else {
                        setVerificationMessage(INVALID_VERIFICATION_LINK);
                        setIsSuccess(false);
                    }
                })
                .catch(() => {
                    setVerificationMessage(INVALID_VERIFICATION_LINK);
                    setIsSuccess(false);
                })
                .finally(() => setLoading(false));
        } else {
            setVerificationMessage(INVALID_VERIFICATION_LINK);
            setIsSuccess(false);
            setLoading(false);
        }
    }, [email, otp]);



    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            <h1 className="text-2xl font-bold mb-4">Verifica dell'account</h1>
            {loading ? (
                <p className="text-gray-600">Verifica del tuo account in corso...</p>
            ) : (
                <p style={{ color: isSuccess ? "green" : "red" }}>
                    {verificationMessage}
                </p>
            )}

            <Link to='/auth/login'>
                <button
                    type='button'
                    id='kt_login_password_reset_form_cancel_button'
                    className='btn btn-primary'
                >
                    Vai al login
                </button>
            </Link>
        </div>
    );
}
